import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const PaymentNotReceived = ({
  id,
  isPaymentNotReceived,
  handleCancelTransaction,
  handleCheckStatus,
}) => {
  return (
    <SlidePanel isOpen={isPaymentNotReceived} onClose={handleCancelTransaction}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <div
          onClick={handleCancelTransaction}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        {/* Content */}
        <div className="flex flex-col items-center justify-center h-full px-5 text-center">
          {/* Icon */}
          <div className="flex items-center justify-center mt-5">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_5373_7021)">
                <path
                  d="M0 25C0 18.3696 2.63392 12.0107 7.32233 7.32233C12.0107 2.63392 18.3696 0 25 0C31.6304 0 37.9893 2.63392 42.6777 7.32233C47.3661 12.0107 50 18.3696 50 25C50 31.6304 47.3661 37.9893 42.6777 42.6777C37.9893 47.3661 31.6304 50 25 50C18.3696 50 12.0107 47.3661 7.32233 42.6777C2.63392 37.9893 0 31.6304 0 25ZM18.75 21.875C19.5788 21.875 20.3737 21.5458 20.9597 20.9597C21.5458 20.3737 21.875 19.5788 21.875 18.75C21.875 17.9212 21.5458 17.1263 20.9597 16.5403C20.3737 15.9542 19.5788 15.625 18.75 15.625C17.9212 15.625 17.1263 15.9542 16.5403 16.5403C15.9542 17.1263 15.625 17.9212 15.625 18.75C15.625 19.5788 15.9542 20.3737 16.5403 20.9597C17.1263 21.5458 17.9212 21.875 18.75 21.875ZM34.375 18.75C34.375 17.9212 34.0458 17.1263 33.4597 16.5403C32.8737 15.9542 32.0788 15.625 31.25 15.625C30.4212 15.625 29.6263 15.9542 29.0403 16.5403C28.4542 17.1263 28.125 17.9212 28.125 18.75C28.125 19.5788 28.4542 20.3737 29.0403 20.9597C29.6263 21.5458 30.4212 21.875 31.25 21.875C32.0788 21.875 32.8737 21.5458 33.4597 20.9597C34.0458 20.3737 34.375 19.5788 34.375 18.75ZM30.4437 34.85C30.9796 35.4824 31.7447 35.876 32.5707 35.9443C33.3967 36.0125 34.2161 35.7499 34.8484 35.2141C35.4808 34.6782 35.8744 33.9132 35.9427 33.0871C36.011 32.2611 35.7483 31.4418 35.2125 30.8094L35.2062 30.8031L35.1969 30.7906L35.175 30.7656L35.1188 30.7031C34.897 30.4565 34.6623 30.2218 34.4156 30C33.8143 29.4623 33.1623 28.984 32.4688 28.5719C30.2095 27.2323 27.6264 26.5374 25 26.5625C22.3736 26.5374 19.7905 27.2323 17.5312 28.5719C16.624 29.1142 15.7892 29.7695 15.0469 30.5219L14.8813 30.7L14.825 30.7656L14.8031 30.7906L14.7938 30.8031L14.7875 30.8125C14.2742 31.4475 14.0298 32.2581 14.1066 33.071C14.1834 33.8839 14.5753 34.6345 15.1984 35.1621C15.8216 35.6897 16.6265 35.9525 17.4409 35.8941C18.2554 35.8358 19.0146 35.461 19.5562 34.85L19.5719 34.8344C19.601 34.801 19.6656 34.7385 19.7656 34.6469C20.0695 34.3758 20.3992 34.1351 20.75 33.9281C22.0373 33.173 23.5078 32.787 25 32.8125C26.95 32.8125 28.3531 33.3906 29.25 33.9281C29.6774 34.1823 30.0729 34.4865 30.4281 34.8344L30.4437 34.85Z"
                  fill="#FFCB35"
                />
              </g>
              <defs>
                <clipPath id="clip0_5373_7021">
                  <rect width="50" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          {/* Text */}
          <div className="mt-6">
            <p className="text-[#060606] text-[16px] font-semibold">
              Payment not received
            </p>
            <p className="mt-2 text-[#4A4747] text-[14px]">
              Your payment was unsuccessful!
            </p>
          </div>

          {/* Buttons */}
          <div className="flex gap-4 mt-6 w-full">
            <button
              onClick={handleCheckStatus}
              className="w-1/2 text-[#005C53] bg-white border border-[#005C53] rounded-[5px] py-2.5"
            >
              Try Again
            </button>

            <button
              onClick={handleCheckStatus}
              className="w-1/2 bg-[#005C53] text-white border border-[#005C53] rounded-[5px] py-2.5"
            >
              Review Details
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default PaymentNotReceived;
